import HorizontalRule from 'components/HorizontalRule';
import React from 'react';
import { Button, Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import OneTimeShift from '../Shift/OneTimeShift';
import moment from 'moment';
import { AddButton, DeleteButton } from 'components/V2/Buttons';
import ConfirmationModal from 'components/V2/ConfirmationModal';
import DeleteDayModal from 'components/V2/ConfirmationModal/DeleteDayModal';
import { sortBy } from 'lodash';

const DaysListItem = (props) => {
  const [open, setOpen] = React.useState(props.open);
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [openDeleteDayModal, setOpenDeleteDayModal] = React.useState(false);
  const { idx, date, shifts, days, editMode } = props;

  const toggleDeleteModal = () =>
    setOpenDeleteModal(!openDeleteModal)

  const toggleDeleteDayModal = () =>
    setOpenDeleteDayModal(!openDeleteDayModal);

  const canDeleteShift = (idx = 'last') => {
    if (idx === 'last') return shifts.length > 1;

    return shifts.length > 1 && shifts.length - 1 > idx;
  };

  const onDeleteDay = () => props.removeMultipleShifts(shifts.flatMap(({ idx }) => idx));

  const onAddShift = () => {
    const { idx, rateTypeId, payRate } = props.shiftLocation;
    const { zipCode } = props.shiftLocation.address;
    const schedule = {
      startDate: moment(date).format('YYYY-MM-DD'),
      endDate: moment(date).format('YYYY-MM-DD'),
      start: '',
      end: '',
    };
    props.addShift({ locationId: idx, zipCode, schedule, rateTypeId, payRate });
  };

  const isDateDisabled = (shift, mapIdx) => {
    const { tournamentEndDate } = props;
    return (
      !shift || moment(shift.startTime).isSameOrBefore(moment(tournamentEndDate)) || mapIdx !== 0
    );
  };

  return (
    <li className="days-list-item" key={`li-${idx}`}>
      <Card key={idx} className="border-0">
        <CardHeader className="day-header">
          <Button color="link" className="day-btn gotham-bold-font" onClick={() => setOpen(!open)}>
            <i className={`arrow fas fa-chevron-${open ? 'down' : 'right'}`}></i>
            Day {idx + 1}: &nbsp;&nbsp;
            {moment(date).isValid() ? moment(date).format('MM/DD/YY') : 'Select Date'}
          </Button>
          {days.length > 1 && (
            <React.Fragment>
              <DeleteButton
                className="float-right"
                onClick={toggleDeleteDayModal}
              >
                DELETE DAY
              </DeleteButton>
              {editMode ? <DeleteDayModal
                isOpen={openDeleteDayModal}
                title="Delete day"
                body={`Deleting this day on ${moment(date).format('MM/DD/YYYY')} will remove athletic trainers who applied or confirmed to work.`}
                toggle={toggleDeleteDayModal}
                onDelete={onDeleteDay}
                items={sortBy(shifts.filter(shift => moment(shift.startDate).isSame(moment(date))), shift => moment(shift.startTime))}
                user={props.user}
                eventName={props.eventName}
              /> : <ConfirmationModal
                isOpen={openDeleteDayModal}
                toggle={toggleDeleteDayModal}
                title="Delete Day"
                body={`Are you sure you want to delete this day: ${moment(date).format('MM/DD/YYYY')}?`}
                onSave={onDeleteDay}
                onCancel={toggleDeleteDayModal}
                confirmText="Delete"
                cancelText="Go Back"
              />}
            </React.Fragment>
          )}
        </CardHeader>
        <HorizontalRule dashed={open} margin="0" />
        <Collapse isOpen={open}>
          <CardBody className={`py-1`}>
            {shifts.map((shift, mapIdx) => (
              <OneTimeShift
                from="tournament"
                key={shift.idx}
                idx={shift.idx}
                mapIdx={mapIdx}
                shift={shift}
                hasBottomBorder={shift.idx !== shifts.length - 1}
                canDelete={canDeleteShift(mapIdx)}
                wasValidated={props.wasValidated}
                onChangeField={props.onChangeField(shift.idx)}
                onChangeShift={props.onChangeShift(shift.idx)}
                onDeleteShift={props.onDeleteShift(shift.idx)}
                dateDisabled={isDateDisabled(shift, mapIdx)}
                editMode={editMode}
                user={props.user}
                eventName={props.eventName}
              />
            ))}
            <div className="actions my-3">
              <AddButton onClick={onAddShift}>ADD ANOTHER SHIFT</AddButton>
              <DeleteButton
                show={canDeleteShift()}
                className="ml-2"
                onClick={toggleDeleteModal}
              >
                DELETE SHIFT
              </DeleteButton>
              <ConfirmationModal
                isOpen={openDeleteModal}
                toggle={toggleDeleteModal}
                title="Delete Shift"
                body={`Are you sure you want to delete this shift on ${moment(shifts.at(-1)?.startDate).format('MM/DD/YYYY')}?`}
                onSave={props.onDeleteShift(shifts.at(-1).idx)}
                onCancel={toggleDeleteModal}
                confirmText="Delete"
                cancelText="Go Back"
              />
            </div>
          </CardBody>
          <HorizontalRule margin="0" />
        </Collapse>
      </Card>
    </li>
  );
};

export default DaysListItem;
